import React, { useEffect } from "react";

import styled from "styled-components";



const SectionWrapper = styled.section`
  background-color: #fefefe;
  padding: 4rem 1.5rem;

  @media (min-width: 768px) {
    padding: 5rem 4rem;
  }
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const BulletList = styled.ul`
  text-align: left;
  margin: 0 auto 2rem;
  max-width: 600px;
  padding-left: 1.2rem;

  li {
    font-size: 1rem;
    color: #444;
    margin-bottom: 0.8rem;
  }
`;

const InfoBox = styled.div`
  background-color: #eef6ff;
  color: #003d73;
  padding: 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  margin: 1.5rem 0;
  text-align: center;
  font-weight: 500;
  line-height: 1.6;
`;

const CTAButton = styled.a`
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 1.8rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  display: inline-block;
  transition: background 0.3s ease;

  &:hover {
    background-color: #005fa3;
  }
`;




const ViewTroca = () => {
  return (
    <SectionWrapper>
      <Content>
        <Title>Não vai usar sua cota neste período?</Title>

        <Paragraph>
          Em vez de deixar sua cota parada ou tentar alugar sem sucesso, você pode simplesmente
          <strong> trocar sua semana com outro proprietário</strong> cadastrado na plataforma.
        </Paragraph>

        <BulletList>
          <li>🔁 Flexibilidade total para quem não pode usar o período original</li>
          <li>📍 Trocas dentro do mesmo resort ou com outros destinos disponíveis</li>
          <li>📅 Ideal para quem quer variar as datas ou combinar com férias reais</li>
          <li>✅ Propriedades checadas, sua viagem segura e maior tranquilidade</li>
          <li>📋 Contrato de locação para garantir segurança a todas as partes envolvidas</li>
        </BulletList>

        <Paragraph>
          Nós cuidamos da intermediação, apresentamos as opções disponíveis e garantimos a troca
          com segurança para os dois lados.
        </Paragraph>

        <InfoBox>
          💰 A troca só tem custo <strong>se for realizada com sucesso</strong>:  
          uma taxa única de <strong>R$ 147,00 por proprietário</strong> para cobrir todo o suporte e agendamento.
        </InfoBox>

        <Paragraph>
          ✅ Sem riscos. Sem mensalidade. Você só paga se conseguir trocar.
        </Paragraph>

        <CTAButton href="#formulario">Quero cadastrar minha cota para troca</CTAButton>
      </Content>
    </SectionWrapper>
  );
};

export default ViewTroca;





